import AppleMapsEsque from './AppleMapsEsque.json';
import AvocadoWorld from './AvocadoWorld.json';
import Bentley from './Bentley.json';
import BlueEssence from './BlueEssence.json';
import BlueWater from './BlueWater.json';
import Elevation from './Elevation.json';
import Hopper from './Hopper.json';
import MidnightCommander from './MidnightCommander.json';
import Nature from './Nature.json';
import NeutralBlue from './NeutralBlue.json';
import PaleDawn from './PaleDawn.json';
import Paper from './Paper.json';
import Retro from './Retro.json';
import Shady from './Shady.json';
import SubtleGrayscale from './SubtleGrayscale.json';
import UltraLight from './UltraLight.json';
import UnsaturatedBrowns from './UnsaturatedBrowns.json';

export default [
  {map: [], name: 'Default', id: -1, image: 'default.png'},
  {map: AppleMapsEsque, name: 'Apple Maps-esque', id: 0, image: '42-apple-maps-esque.png'},
  {map: AppleMapsEsque, name: 'Avocado World', id: 16, image: '35-avocado-world.png'},
  {map: Bentley, name: 'Bentley', id: 1, image: '43-bentley.png'},
  {map: BlueWater, name: 'Blue Water', id: 2, image: '25-blue-water.png'},
  {map: BlueEssence, name: 'Blue Essence', id: 3, image: '61-blue-essence.png'},
  {map: Elevation, name: 'Elevation', id: 4, image: '6285-elevation.png'},
  {map: Hopper, name: 'Hopper', id: 5, image: '21-hopper.png'},
  {map: MidnightCommander, name: 'Midnight', id: 6, image: '2-midnight-commander.png'},
  {map: Nature, name: 'Nature', id: 7, image: '47-nature.png'},
  {map: NeutralBlue, name: 'Neutral Blue', id: 8, image: '13-neutral-blue.png'},
  {map: PaleDawn, name: 'Pale Dawn', id: 9, image: '1-pale-dawn.png'},
  {map: Paper, name: 'Paper', id: 10, image: '39-paper.png'},
  {map: Retro, name: 'Retro', id: 11, image: '18-retro.png'},
  {map: Shady, name: 'Shady', id: 12, image: '38-shades-of-grey.png'},
  {map: SubtleGrayscale, name: 'Subtle Grayscale', id: 13, image: '15-subtle-grayscale.png'},
  {map: UltraLight, name: 'Ultra Light', id: 14, image: '151-ultra-light-with-labels.png'},
  {map: UnsaturatedBrowns, name: 'Unsaturated Browns', id: 15, image: '70-unsaturated-browns.png'}
];